<template>
  <ReservationHero v-if="websiteStatus == 1" />

  <div v-else class="landing">
    <HomePageRenderer
      :auth="auth"
      :user="user"
      :testimonials="testimonials"
      :testimonials-loading="testimonialsLoading"
    />
    <MyTestimonialEditor
      v-if="auth"
      :my-testimonial="myTestimonial"
      @saved="onTestimonialSaved"
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';

import ReservationHero      from '@/components/home/ReservationHero.vue';
import HomePageRenderer     from '@/components/home/HomePageRenderer.vue';
import MyTestimonialEditor  from '@/components/home/MyTestimonialEditor.vue';
import { useTestimonials }  from '@/composables/useTestimonials';

const store = useStore();

const websiteStatus = ref(localStorage.getItem('website_status') || 0);
const auth = ref(store.getters['isAuthenticated']);
const user = ref(JSON.parse(localStorage.getItem('user') || 'null'));

const {
  testimonials,
  testimonialsLoading,
  myTestimonial,
  fetchTestimonials,
  fetchMyTestimonial,
} = useTestimonials();

function onTestimonialSaved(updatedData) {
  myTestimonial.value = updatedData;
  fetchTestimonials();
}

onMounted(() => {
  fetchTestimonials();
  if (auth.value) fetchMyTestimonial();
});
</script>

<style scoped>
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
.landing { font-family: 'Cairo', sans-serif; direction: rtl; overflow-x: hidden; }

/* Mobile app home: keep a light app background behind the compact sections.
   Clearing the fixed bottom nav is handled globally by style.min.css's
   `body { padding-bottom: var(--bottom-nav-height, 72px) }` rule (kept in
   sync with BottomNav's real rendered height via a ResizeObserver) — this
   used to duplicate that same reservation here too. Small fixed cushion
   kept, not tied to bottom-nav height. */
@media (max-width: 768px) {
  .landing {
    background: #F5F7FB;
    padding-bottom: 8px;
  }
}
</style>
